import styled, { css } from 'styled-components';
import { Heading } from '../heading/index.js';
import { Paragraph } from '../paragraph/index.js';
import { suppressProps } from '../../utils/index.js';
export const IconWrapper = styled.div ``;
export const EmptyStateHeading = styled(Heading) ``;
export const EmptyStateParagraph = styled(Paragraph) ``;
export const ContentWrapper = styled.div ``;
export const ActionsWrapper = styled.div ``;
export const EmptyStateElement = styled.div.withConfig(suppressProps('isMobile'))(({ theme, isMobile }) => {
    const margin = isMobile ? theme.space.x4 : theme.space.x6;
    const headingMargin = isMobile ? theme.space.x1 : theme.space.x3;
    return css `
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      white-space: pre-wrap;

      ${IconWrapper} {
        margin-bottom: ${margin};
      }

      ${EmptyStateHeading} {
        margin-bottom: ${headingMargin};
      }

      ${ActionsWrapper} {
        margin-top: ${margin};
      }
    `;
});
//# sourceMappingURL=empty-state.styles.js.map